<template>
        <div id='points'>
              <NavTop title='积分中心' :islink='true' linkurl='/my'/>
              <div class='content'>
                  <div class="panel">
                      <div class="part1">
                          <div class="part1-line">本月预估获得积分</div>
                          <div class="part1-line" @click="goDetail(2,0)">{{prize.thismonth}}</div>
                          <div class="part1-line smallfont" @click="goDetail(1,0)">今日预估获得积分{{prize.today}}</div>
                      </div>
                      
                      <div class="part2">
                        <div class="part2-col4" @click="goDetail(2,4)">
                            <div>零售积分</div>
                            <div>{{prize.lspoints}}</div>
                        </div>
                        <div class="part2-col4" @click="goDetail(2,1)">
                            <div>扶持积分</div>
                            <div>{{prize.fcpoints}}</div>
                        </div>
                        <div class="part2-col4" @click="goDetail(2,3)">
                            <div>业绩积分</div>
                            <div>{{prize.yjpoints}}</div>
                        </div>
                        <div class="part2-col4">
                            <div>双亲积分</div>
                            <div>{{prize.sqpoints}}</div>
                        </div>
                        <div class="part2-col4"  @click="goDetail(2,5)">
                            <div>发货积分</div>
                             <div>{{prize.fhpoints}}</div>
                        </div>
                        <div class="part2-col4"  @click="goDetail(2,6)">
                            <div>邀约积分</div>
                             <div>{{prize.yypoints}}</div>
                        </div>
                      </div>
                      <van-divider>销售概况</van-divider>
                      <div class="part2">
                          <div class="part2-col4">
                              <div>本月下单</div>
                              <div>{{prize.ordernums}}人</div>
                          </div>
                          <div class="part2-col4">
                            <div>本月销售</div>
                            <div>{{prize.salenums}}盒</div>
                          </div>
                          <div class="part2-col4">
                            <div>本月访客</div>
                            <div>{{prize.visitors}}人</div>
                          </div>
                      </div>
                      
                      <div class="part4">
                          <van-divider>客户订单</van-divider>
                          <div class="part4-line2">
                             <div class="part4-col">
                                 <div>{{prize.o15}}</div>
                                 <div>订单未成功</div>
                             </div>
                             <div class="part4-col">
                                <div>{{prize.o3}}</div>
                                <div>订单待收货</div>
                            </div>
                            <div class="part4-col">
                                <div>{{prize.o4}}</div>
                                <div>订单已签收</div>
                            </div>
                            <div class="part4-col">
                                <div>{{prize.service}}</div>
                                <div>订单售后中</div>
                            </div>
                          </div>
                      </div>
                      <van-divider>汇总提现</van-divider>
                      <div class="part3">
                          <div class="txwords" @click="goDetail(3,0)">已结算获得积分 ：{{prize.total}}积分</div>
                          <!--<div class="txbtn" @click="goWithdraw">去提现</div>-->
                      </div>
                  </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import { Divider } from 'vant';

export default {
  name: 'points',
  data(){
      return{
         prize:{} 
      }
  },  
  created(){
      this.getList()
  },
  methods: {
      getList(){
         this.$post("/prize/getPrizeInfo",{}).then((data)=>{
             if(data.result.success){
                 this.prize=data.result.info
             }
         })
      },
      goWithdraw(){
          this.$go("/withdraw")
      },
      goDetail(type,ptype){
          this.$go("/pointsdetail/"+type+"/"+ptype)
      }
  },
  components:{
      NavTop,
      [Divider.name]:Divider
  }
}
</script>
<style scoped>
#points{background-color:#F6F6F6;min-height: 100vh;}
.content{font-size:0.5rem;overflow-x:hidden;word-break:break-all;text-align: left;padding: 0.4rem;}
.panel{display: flex;flex-flow: column nowrap;border-radius: 0.2rem;background-color: #fff;padding: 0.35rem;}
.part1{display: flex;flex-flow: column nowrap;}
.part1-line{font-size: 0.5rem; text-align: center;padding: 0.12rem;}
.smallfont{font-size: 0.35rem;}
.part2{display: flex;flex-flow: row wrap;width:100%;}
.part2-col{display: flex;flex-flow: column nowrap;width:33.3%;font-size:0.4rem;text-align: center;padding: 0.12rem;}
.part2-col4{display: flex;flex-flow: column nowrap;width:25%;font-size:0.4rem;text-align: center;padding: 0.12rem;}

.part3{display: flex;font-size:0.35rem;margin: 0.2rem 0;padding: 0.1rem;align-items: center;}
.txwords{padding: 0.1rem;}
.txbtn{margin-left: auto;padding: 0.15rem;background-color:#ee0a24;color:#fff;border-radius: 0.15rem;}
.part4{display: flex;flex-flow: column nowrap;}
.part4-line1{font-size:0.35rem;padding: 0.1rem;}
.part4-line2{display: flex;flex-flow: row nowrap;}
.part4-col{display: flex;flex-flow: column nowrap;font-size: 0.35rem;flex:0 0 25%;text-align: center;}
.split{height: 1px;width:100%;background-color: #ccc;}
</style>


